import React from "react";
import AppModal from "./AppModal";
import BottomShine from "../assets/img/subject_underline_shine_effect.png";


const dialogStyle = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30vw',
        maxWidth: '30vw',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: '0px',
        background: '',
        padding: "3px 3px",
        textAlign: "center",
        backgroundSize: "100% 100%",
        alignItems: "center",
        overflow: "hidden",
    },
    overlay: {
        zIndex: 900,
    }
};

const ThankYouModal = ({modalIsOpen, handleCloseModal, title, body}) => {

    return(
        <AppModal
            isOpen={modalIsOpen}
            handleCloseModal={handleCloseModal}
            propsStyle={dialogStyle}
            contents={
                <div className={'modal-content-help'}>
                    <div className={'modal-header'}>
                        <h4 style={{fontSize: '1.1vw', margin: 7}}>{title}</h4>
                        <div className={'close-button-help'} onClick={handleCloseModal}>X</div>
                    </div>
                    <div style={{display: 'flex', width: '140%'}}>
                        <img src={BottomShine} style={{height: 5, width: '100%'}} alt={''}/>
                    </div>
                    <div className={'modal-body help-popup'}>
                        <div style={{fontSize: '1.1vw', color: '#fff', margin: '1.3vw'}}>
                            {body}
                        </div>
                    </div>
                </div>
            }
        />
    )
};

export default ThankYouModal;